export default __webpack_public_path__ + "static/media/boat-painting.baf56f11.png";